import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-fingerprint-result',
    templateUrl: './fingerprint-result.component.html',
    styleUrls: ['./fingerprint-result.component.scss']
})
export class FingerprintResultComponent implements OnInit {
    @Input() title: string;
    @Input() desc: string;
    @Input() isLoginWithMax: boolean;
    @Input() registrationUrl: string;
    @Output() emitbtn: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor() {}

    ngOnInit(): void {}
}
